import { brand } from '@/styles/shared';
interface StarIconProps {
  width?: number;
  height?: number;
  fill?: string;
}

const StarIcon = ({ width = 20, height = 20, fill = brand.purpleAccent }: StarIconProps) => {
  return (
    <svg width={width} height={height} viewBox="0 0 20 20" fill="none">
      <path
        d="M10 0L12.245 7.755L20 10L12.245 12.245L10 20L7.755 12.245L0 10L7.755 7.755L10 0Z"
        fill={fill}
      />
    </svg>
  );
};

export default StarIcon;
